//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from "vuex-pathify"

export default {
  data() {
    return {
      examen: this.$store.copy('examen/seleccion')
    }
  },

  methods: {
    async submit() {
      await this.$store.dispatch("examen/update", this.examen)
      this.$emit("submit", this.examen)
    },
  },
}
